<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="@/assets/back.png" alt="返回" />
          <span>返回</span>
        </div>
      </div>
      <Title class="mt20">基础信息</Title>
      <el-descriptions class="margin-top" title="" :column="3">
        <el-descriptions-item label="活动名称">{{info.activityName}}</el-descriptions-item>
        <el-descriptions-item label="套餐金额">{{info.rechargeMoney}}元</el-descriptions-item>
        <el-descriptions-item label="获得奖励">{{info.rewardType==1?info.name:info.rewardType==2?info.xiaoduMoney+'个零售价':'-'}}</el-descriptions-item>
        <el-descriptions-item label="是否限制时间">{{info.isLimit?'限制':'不限制'}}</el-descriptions-item>
        <el-descriptions-item label="套餐上架时间">{{info.showTime}}</el-descriptions-item>
        <el-descriptions-item label="体验班充值大区分润比例">{{info.experienceRatio}}%</el-descriptions-item>
        <el-descriptions-item label="研修班充值大区分润比例">{{info.trainingRatio}}%</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{info.createdTime}}</el-descriptions-item>
        <el-descriptions-item label="状态">{{info.state?'上架':'下架'}}</el-descriptions-item>
      </el-descriptions>
      
      <!-- 主图展示 -->
      <Title class="mt20" v-if="info.mainImg">主图</Title>
      <div v-if="info.mainImg" class="image-display">
        <el-image 
          :src="info.mainImg" 
          :preview-src-list="[info.mainImg]"
          style="width: 200px; height: 150px; border-radius: 8px;"
          fit="cover">
        </el-image>
      </div>
      
      <!-- Banner图展示 -->
      <Title class="mt20" v-if="info.bannerImg">Banner图</Title>
      <div v-if="info.bannerImg" class="banner-display">
        <el-image 
          v-for="(img, index) in bannerImages" 
          :key="index"
          :src="img" 
          :preview-src-list="bannerImages"
          style="width: 200px; height: 150px; border-radius: 8px; margin-right: 10px; margin-bottom: 10px;"
          fit="cover">
        </el-image>
      </div>
      
      <!-- 活动详情展示 -->
      <Title class="mt20" v-if="info.detail">活动详情</Title>
      <div v-if="info.detail" class="detail-content" v-html="info.detail"></div>
    </el-card>
  </div>
</template>

<script>
import Title from '@/components/Title'

export default {
  components: {
    Title
  },
  props: ['rowItem'],
  data() {
    return {
      info: {}
    }
  },
  computed: {
    bannerImages() {
      if (!this.info.bannerImg) return []
      return this.info.bannerImg.split(',').filter(img => img.trim())
    }
  },
  created() {
    this.handleShow()
  },
  methods: {
    handleShow() {
      this.info = this.rowItem
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.title-box {
  margin-bottom: 0;
}
::v-deep .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 0 !important;
  padding-top: 30px;
}
</style>
